class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.buttonObserver = null;
    this.footerObserver = null;
    this.buttonHidden = false;
    this.footerVisible = false;
  }

  connectedCallback() {
    // Move element to body to escape section stacking context
    document.body.appendChild(this);

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    const originalButton = document.querySelector(
      '.pdp-atc button[type="submit"]',
    );
    const footer = document.querySelector("#shopify-section-group-footer");

    if (!originalButton) {
      return;
    }

    // Delegate clicks to the real product add-to-cart button so the floating
    // button inherits the exact same photo-upload gating as the main button
    // (Upload Lift requires at least one photo). Submitting the form directly
    // from the floating button would bypass that requirement.
    const stickyButton = this.querySelector('button[type="submit"]');
    if (stickyButton) {
      stickyButton.addEventListener("click", (event) => {
        event.preventDefault();
        originalButton.click();
      });
    }

    // Watch original ATC button
    this.buttonObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.buttonHidden = !entry.isIntersecting;
          this.updateVisibility();
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0,
      },
    );
    this.buttonObserver.observe(originalButton);

    // Watch footer — hide sticky bar when footer is visible
    if (footer) {
      this.footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.footerVisible = entry.isIntersecting;
            this.updateVisibility();
          });
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0,
        },
      );
      this.footerObserver.observe(footer);
    }
  }

  updateVisibility() {
    this.classList.toggle("visible", this.buttonHidden && !this.footerVisible);
  }

  disconnectedCallback() {
    if (this.buttonObserver) {
      this.buttonObserver.disconnect();
    }
    if (this.footerObserver) {
      this.footerObserver.disconnect();
    }
  }
}

customElements.define("sticky-add-to-cart", StickyAddToCart);
